var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course-ware-content",attrs:{"native":false}},[_c('wareDetailModule',{attrs:{"typeId":_vm.typeId,"zhangIndex":_vm.zhangIndex,"jieIndex":_vm.jieIndex,"file_path":_vm.file_path,"resource_id":_vm.resource_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }